import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70f07688"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f07688')) {
      api.createRecord('70f07688', component.options)
    } else {
      api.reload('70f07688', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70f07688", function () {
      api.rerender('70f07688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/index.vue"
export default component.exports